import React from 'react';
import { motion } from 'framer-motion';
import { Hotel, Newspaper, Map, UtensilsCrossed, Briefcase, PartyPopper } from 'lucide-react';

const ITEMS = [
  { icon: Hotel, title: 'Hotelaria', pain: 'Hóspede compara diária.', win: 'Mostramos a experiência que justifica o valor.' },
  { icon: Newspaper, title: 'Jornalismo & Mídia', pain: 'Notícia sozinha não fideliza.', win: 'Construímos marca, linguagem e audiência fiel.' },
  { icon: Map, title: 'Turismo', pain: 'Todo passeio parece igual.', win: 'Fazemos o turista desejar o seu antes de chegar.' },
  { icon: UtensilsCrossed, title: 'Gastronomia', pain: 'O cardápio vira tabela de preço.', win: 'Transformamos o prato em motivo de visita.' },
  { icon: Briefcase, title: 'Profissionais', pain: 'Competência que ninguém vê.', win: 'Autoridade visível para quem deveria te contratar.' },
  { icon: PartyPopper, title: 'Eventos', pain: 'Acaba e ninguém lembra.', win: 'Registro e narrativa que vendem a próxima edição.' },
];

export const Segments = () => (
  <section id="setores" className="relative py-28 sm:py-36 bg-[var(--br-bg-2)]" data-testid="segments-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-3xl">
        <p className="br-mono text-[11px] text-[var(--br-teal)]">Para quem é</p>
        <h2 className="mt-5 text-3xl sm:text-5xl font-semibold leading-tight">Cada setor tem um dilema. <span className="italic text-white/60">A estratégia resolve.</span></h2>
      </div>
      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 rounded-[24px] overflow-hidden border border-white/10">
        {ITEMS.map((s, i) => (
          <motion.div
            key={s.title}
            initial={{ opacity: 0, rotateX: 25, y: 30 }}
            whileInView={{ opacity: 1, rotateX: 0, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: (i % 3) * 0.08 }}
            className="group bg-[var(--br-bg-2)] p-8 sm:p-10 transition-colors duration-300 hover:bg-[#18202A]"
            style={{ transformPerspective: 900 }}
            data-testid={`segment-${i}`}
          >
            <s.icon className="w-7 h-7 text-[var(--br-teal)] transition-transform duration-300 group-hover:-translate-y-1" />
            <h3 className="mt-6 text-2xl font-semibold">{s.title}</h3>
            <p className="mt-4 text-sm text-white/45 line-through decoration-[var(--br-wine)]">{s.pain}</p>
            <p className="mt-2 text-base text-white/85">{s.win}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
